
import { Component, Vue } from 'vue-property-decorator'
import { authService } from '@/services/auth-service'

@Component
export default class TopNavigation extends Vue {
    get userIsAdmin() { return authService.isAuthorized('ADMIN') }

    get allNavigationItems() {
        return [
            {
                route: '/mailwizzes',
                text: 'Mailwizzes',
                admin: true
            },
            {
                route: '/testcases',
                text: 'Test Cases',
                admin: false
            },
            {
                route: '/tracking-domains',
                text: 'Tracking Domains',
                admin: true
            },
            {
                route: '/users',
                text: 'Users',
                admin: true
            },
            {
                route: '/settings',
                text: 'Settings',
                admin: true
            }
        ]
    }

    get userNavigationItems() {
        return this.allNavigationItems.filter(x => !x.admin || this.userIsAdmin)
    }
}
